export const jsonSerializer =
  <T>(serialize: (data: any) => T = (data: any) => data as T) =>
  async (response: Response) => {
    const data = await response.json();
    return serialize(data);
  };
